import { render, staticRenderFns } from "./Tecal.vue?vue&type=template&id=1b3b6ac0&lang=true"
import script from "./Tecal.vue?vue&type=script&lang=js"
export * from "./Tecal.vue?vue&type=script&lang=js"
import style0 from "./Tecal.vue?vue&type=style&index=0&id=1b3b6ac0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports